import React, { useState, useEffect } from "react";
import "./LoadingClock.scss";

const LoadingClock = ({ delay = 1000 }) => {
	const [loadedCount, setLoadedCount] = useState(0);

	useEffect(() => {
		const interval = setInterval(() => {
			setLoadedCount((count) => {
				if(count > 20) {
					return 0;
				}
				return count+1;
			});
		}, delay);

		return () => clearInterval(interval);
	}, [delay]);

	const renderCircles = () => {
		const circles = [];
		for (let i = 0; i < 20; i++) {
			const loaded = loadedCount >= i;
			circles.push(<div key={i} className={`circle ${loaded ? "loaded" : ""}`} />);
		}
		return circles;
	};

	return (
		<div className="loading-container">
			<div className="loading-clock">{renderCircles()}</div>
		</div>
	);
};

export default LoadingClock;
